import React from 'react';
import { Grid, Box } from '@material-ui/core';

import { OrangeButton } from 'components/Button';
import {
  StyledGridImg,
  StyledGrid,
  StyledImgDiv,
  StyledLongBody,
  StyledLargeSectionHeader,
} from 'components/MyOffers/styles';
import GaClickHOC from 'helpers/GATracking/GaClickHOC';

export interface MyOffersType {
  title: string;
  subTitle: string;
  body: string;
  actionPath: string;
  actionLabel: string;
  image: string;
  gaLabel: string;
  category: string;
}

const MyOffers = (props: MyOffersType) => {
  const {
    title,
    subTitle,
    body,
    actionPath,
    actionLabel,
    image,
    gaLabel,
    category,
  } = props;

  return (
    <StyledGrid container alignItems="center">
      <Grid item xs={12} sm={6}>
        <Grid container>
          <Grid item xs={11}>
            <Box paddingLeft={[2, 8, 13]} py={[4, 3, 2]}>
              <StyledLargeSectionHeader weight="400">
                {title}
                <b> {subTitle} </b>
              </StyledLargeSectionHeader>
            </Box>
          </Grid>
          <Grid item xs={12} sm={8}>
            <Box px={2} paddingLeft={[2, 8, 13]}>
              <StyledLongBody>{body}</StyledLongBody>
              <GaClickHOC category={category} label={gaLabel}>
                <Box paddingY={[4, 3, 2]}>
                  <OrangeButton
                    variant="contained"
                    onClick={() => {
                      window.open(actionPath);
                    }}
                  >
                    {actionLabel}
                  </OrangeButton>
                </Box>
              </GaClickHOC>
            </Box>
          </Grid>
        </Grid>
      </Grid>
      <StyledGridImg item xs={12} sm={6}>
        <StyledImgDiv backgroundImage={image} />
      </StyledGridImg>
    </StyledGrid>
  );
};

export default MyOffers;
